import { FC, useContext, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { TabView, TabPanel } from 'primereact/tabview';
import './scenario.css'
import { MdGroup } from 'react-icons/md'
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { HiOutlineIdentification } from 'react-icons/hi'
import { ScenarioSelector } from "./ScenarioSelector/ScenarioSelector";
import { FaExchangeAlt, FaWarehouse } from 'react-icons/fa'
import { ImTruck } from 'react-icons/im'
import { BsFillCloudRainFill } from 'react-icons/bs'
import { MdEnergySavingsLeaf } from 'react-icons/md'
import { Precipitacion } from "./Settings/Precipitacion/Precipitacion";
import { catchResponse } from "../../utils/helperFunctions";
import { Energia } from "./Settings/Energia/Energia";
import { Transporte } from "./Settings/Transporte/Transporte";
import { MdRocketLaunch } from 'react-icons/md'
import { NewScenarioModal } from "./NewScenarioModal/NewScenarioModal";
import { deleteScenarioByID, getScenarioComparisionByTabID, launchSimulation, queuedSimulations, updateScenario } from "../../services/scenario-service";
import { IScenario, IScenarioComparision } from "../../models/ScenarioModel";
import { error, success } from "../../utils/notifications";
import { AiFillSave } from 'react-icons/ai'
import { VscDebugRestart } from 'react-icons/vsc'
import { Tooltip } from "primereact/tooltip";
import { Proveedor } from "./Settings/Proveedor/Proveedor";
import { Pajera } from "./Settings/Pajera/Pajera";
import { SpeedDial } from 'primereact/speeddial';
import { ChangeNameModal } from "../ScenarioPlan/ChangeNameModal/ChangeNameModal";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { UserContext } from "../../Redux/UserContext";
import { FiCommand } from "react-icons/fi";
import { LaunchSimulationModal } from "./LaunchSimulationModal/LaunchSimulationModal";
import { RiProfileLine } from "react-icons/ri";
import { InformacionGeneral } from "./Settings/InformacionGeneral/InformacionGeneral";
import { GiShieldDisabled } from "react-icons/gi";
import { getAllScenarios } from "../../services/home-service";
import { INITIAL_STATE_SCENARIO } from "../../data/constants";

export const Scenario:FC<any> = (props):JSX.Element => {

    const { history } = props

    const [state] = useContext(UserContext)

    const {id,id_compare}:any = useParams()
    
    const [scenarioBase, setScenarioBase] = useState<IScenario>(INITIAL_STATE_SCENARIO)

    const [scenarioComparision, setScenarioComparision] = useState<IScenario>(INITIAL_STATE_SCENARIO)

    const [simulated, setSimulated] = useState<any>({
        scenario_base: false,
        scenario_comparision: false
    })


    const [original, setOriginal] = useState<any>({
        scenario_base : false,
        scenario_comparision: false
    })

    const [comparativa, setComparativa] = useState<boolean>(history?.location?.state?.comparativa ?? false)

    

    const items = [
        {
            label: 'Cambiar nombre',
            icon: 'pi pi-pencil',
            disabled: state?.rol_id !== undefined? [3,4].includes(state.rol_id) || !state.id_plants.includes(scenarioBase.id_plant) : false,
            command: (e:any) => {
                handleOpenChangeNameModal()
                
            }
        },
        {
            label: 'Deshabilitar escenario',
            icon: <GiShieldDisabled size={18} />,
            disabled: state?.rol_id !== undefined? [3,4].includes(state.rol_id) || !state.id_plants.includes(scenarioBase.id_plant) : false,
            command: (e:any) => {
                confirm(e)
                
                
            },
            
        },
        {
            label: 'Nuevo escenario',
            icon: 'pi pi-plus-circle',
            disabled: state?.rol_id !== undefined? [3,4].includes(state.rol_id) || !state.id_plants.includes(scenarioBase.id_plant) : false,
            command: (e:any) => {
                setVisible(true)
                
            }
        },
        {
            label: 'Ver simulación',
            icon: 'pi pi-external-link',
            disabled: !simulated.scenario_base || scenarioBase.simulating || (comparativa && !simulated.scenario_comparision),
            command: () => history.push({
                pathname: `/scenario_plan/${id}/${id_compare}`,
                state: {comparativa:comparativa}
            })
        },
        {
            label: 'Lanzar simulación',
            icon: <MdRocketLaunch size={20} />,
            disabled: state?.rol_id !== undefined? [3,4].includes(state.rol_id) || !state.id_plants.includes(scenarioBase.id_plant) || (!original.scenario_base && simulated.scenario_base) || scenarioBase.simulating : false,
            command: (e:any) => {
                console.log(e)
                handleLaunchSimulacion()
                
            }
        }
    ];

    
    const [flagChangeScenario, setFlagChangeScenario] = useState<boolean>(true)

    const [openChangeNameModal, setOpenChangeNameModal] = useState<boolean>(false)

    const [newScenarioName, setNewScenarioName] = useState<string>("") 

    const [saveLoading, setSaveLoading] = useState<boolean>(false)

    const [launchError, setLaunchError] = useState<boolean>(false)

    const [launchSuccess, setLaunchSuccess] = useState<boolean>(false)

    const [numberQueuedSimulations, setNumberQueuedSimulations] = useState<any>(undefined)

    const [openLaunchSimulationModal, setOpenLaunchSimulationModal] = useState<boolean>(false)

    const [allScenarios, setAllScenarios] = useState<any[]>([])

    const [scenarioToCompare, setScenarioToCompare] = useState<number>(id_compare)

    const [dataPlanificacion, setDataPlanificacion] = useState<any>()

    const [dataPlanificacionMASTER, setDataPlanificacionMASTER] = useState<any>()

    const [dataProvider, setDataProvider] = useState<any>()

    const [dataProviderMASTER, setDataProviderMASTER] = useState<any>()

    const [dataWarehouse, setDataWarehouse] = useState<any>()

    const [dataWarehouseMASTER, setDataWarehouseMASTER] = useState<any>()

    const [dataPrecipitation, setDataPrecipitation] = useState<any>()

    const [dataPrecipitationMASTER, setDataPrecipitationMASTER] = useState<any>()

    const [dataTransport, setDataTransport] = useState<any>()

    const [dataTransportMASTER, setDataTransportMASTER] = useState<any>()

    const [dataEnergy, setDataEnergy] = useState<any>()

    const [dataEnergyMASTER, setDataEnergyMASTER] = useState<any>()

    const [loadingScenarioComparision, setLoadingScenarioComparision] = useState<boolean>(false)

    const [loadingTab, setLoadingTab] = useState<boolean>(false)

    const [tabID, setTabID] = useState<number>(1)

    const [visible, setVisible] = useState<boolean>(false);



    const handleOpenChangeNameModal = () => {
        setOpenChangeNameModal(true)
    }


    const accept = async() => {
        try {
            const res = await deleteScenarioByID(id)
            if(res.status === 200) {
                const { message, code } = res.data
                if(code === 200) {
                    success("El escenario se ha desactivado correctamente.")
                    history.push("/home")
                } else {
                    error(message)
                }
            }
        } catch(err:any) {
            catchResponse(err)
        }
    }

    const reject = () => {
        
    }

    const confirm = (event:any) => {

        
        confirmPopup({
            target: event.originalEvent.currentTarget,
            message: '¿Estás seguro de que deseas desactivar el escenario?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si',
            rejectLabel:'No',
            accept,
            reject
        });
    };


    const handleTabID = (e:any) => {
        const { innerText } = e.target

        switch(innerText) {
            case 'Info. General':
                setTabID(1)
                break;
            case 'Proveedor':
                setTabID(2)
                break;
            case 'Almacén':
                setTabID(3)
                break;
            case 'Transporte':
                setTabID(4)
                break;
            case 'Precipitación':
                setTabID(5)
                break;
            case 'Energía / Consumo':
                setTabID(6)
                break;
            default:
                
        }
    }

    const handleLaunchSimulacion = () => {
        try {
            setOpenLaunchSimulationModal(true)
            setTimeout(async() => {
                const res = await queuedSimulations()
               
                const {data, code} = res.data 
                
                if(code === 200) {
                    
                    setNumberQueuedSimulations(data)

                    if(data < 2) {
                        setTimeout(async() => {
                            let body = {
                                id_scenario: parseInt(id)
                            }
                            try {
                                const res = await launchSimulation(body)
                                const { code, message} = res.data
                                if(code === 200) {
                                    setLaunchSuccess(true)
                                    success(message)
                                } else {
                                    setOpenLaunchSimulationModal(false)
                                    setNumberQueuedSimulations(undefined)
                                    setLaunchError(true)
                                    error("Error lanzando la simulación")
                                }
                            } catch(err:any){
                                setLaunchError(true)
                                catchResponse(err)
                            }
                            
                            
                        },4000)
                    }
                    
                } else {
                    error("Error obteniendo las simulaciones en cola")
                }
            },1000)
            
        } catch(err:any) {
            catchResponse(err)
        }
    }

    const handleRestart = () => {
        setFlagChangeScenario(!flagChangeScenario)
    }


    const handleSaveData = async() => {
        try {
            setSaveLoading(true)
            let body;

            switch(tabID) {
                case 1:
                    let planificaciones:any = {}

                    if(dataPlanificacionMASTER.scenario_base?.anio_inicio_planificacion_a !== dataPlanificacion.scenario_base?.anio_inicio_planificacion_a) planificaciones['anio_inicio_planificacion_a'] = dataPlanificacion.scenario_base?.anio_inicio_planificacion_a
                    if(dataPlanificacionMASTER.scenario_base?.semana_inicio_planificacion_a !== dataPlanificacion.scenario_base?.semana_inicio_planificacion_a) planificaciones['semana_inicio_planificacion_a'] = dataPlanificacion.scenario_base?.semana_inicio_planificacion_a
                    if(dataPlanificacionMASTER.scenario_base?.anio_fin_planificacion_a !== dataPlanificacion.scenario_base?.anio_fin_planificacion_a) planificaciones['anio_fin_planificacion_a'] = dataPlanificacion.scenario_base?.anio_fin_planificacion_a
                    if(dataPlanificacionMASTER.scenario_base?.semana_fin_planificacion_a !== dataPlanificacion.scenario_base?.semana_fin_planificacion_a) planificaciones['semana_fin_planificacion_a'] = dataPlanificacion.scenario_base?.semana_fin_planificacion_a
            
                    if(dataPlanificacionMASTER.scenario_comparision?.anio_inicio_planificacion_b !== dataPlanificacion.scenario_comparision?.anio_inicio_planificacion_b) planificaciones['anio_inicio_planificacion_b'] = dataPlanificacion.scenario_comparision?.anio_inicio_planificacion_b
                    if(dataPlanificacionMASTER.scenario_comparision?.semana_inicio_planificacion_b !== dataPlanificacion.scenario_comparision?.semana_inicio_planificacion_b) planificaciones['semana_inicio_planificacion_b'] = dataPlanificacion.scenario_comparision?.semana_inicio_planificacion_b
                    if(dataPlanificacionMASTER.scenario_comparision?.anio_fin_planificacion_b !== dataPlanificacion.scenario_comparision?.anio_fin_planificacion_b) planificaciones['anio_fin_planificacion_b'] = dataPlanificacion.scenario_comparision?.anio_fin_planificacion_b
                    if(dataPlanificacionMASTER.scenario_comparision?.semana_fin_planificacion_b !== dataPlanificacion.scenario_comparision?.semana_fin_planificacion_b) planificaciones['semana_fin_planificacion_b'] = dataPlanificacion.scenario_comparision?.semana_fin_planificacion_b

                    body = {
                        id_scenario_base: parseInt(id),
                        id_scenario: parseInt(id_compare),
                        comparativa: comparativa,
                        id_tab: tabID,
                        settings : {
                            planificaciones: planificaciones 
                        }
                        
                    }
                    break;
                case 2:
                    let provider_table_edited = dataProvider.provider_table.filter((pt:any) => 'edited' in pt && pt.edited === true)
                    let contract_table_edited = dataProvider.contract_table.filter((pt:any) => 'edited' in pt && pt.edited === true)

                    body = {
                        id_scenario_base: parseInt(id),
                        id_scenario: parseInt(id_compare),
                        comparativa: comparativa,
                        id_tab: tabID,
                        settings : {
                    
                            providers: {
                                provider_table: provider_table_edited,
                                contract_table: contract_table_edited
                            }
                        }
                        
                    }
                    break;
                case 3:
                    let warehouse_table_edited = dataWarehouse?.filter((wt:any) => 'edited' in wt && wt.edited === true)

                    body = {
                        id_scenario_base: parseInt(id),
                        id_scenario: parseInt(id_compare),
                        comparativa: comparativa,
                        id_tab: tabID,
                        settings : {
                            warehouse : warehouse_table_edited
                        }
                        
                    }
                    break;
                case 4:
                    let precio_km_table_edited = dataTransport.precio_km_table.filter((pkmt:any) => 'edited' in pkmt && pkmt.edited === true)
                    let inflacion_esperada_table_edited = dataTransport.inflacion_esperada_table.filter((iet:any) => 'edited' in iet && iet.edited === true)

                    body = {
                        id_scenario_base: parseInt(id),
                        id_scenario: parseInt(id_compare),
                        comparativa: comparativa,
                        id_tab: tabID,
                        settings : {
                            transport: {
                                precio_km_table : precio_km_table_edited,
                                inflacion_esperada_table : inflacion_esperada_table_edited
                            }
                        }
                        
                    }
                    break;
                case 5:
                    let precipitation_table_edited = dataPrecipitation.precipitation_table.filter((pt:any) => 'edited' in pt && pt.edited === true).map((item:any) => {
                        if(comparativa) {
                            return item
                        } else {
                            return {...item,id_zona_a:item.id_zona}
                        }
                    })

                    body = {
                        id_scenario_base: parseInt(id),
                        id_scenario: parseInt(id_compare),
                        comparativa: comparativa,
                        id_tab: tabID,
                        settings : {
                            precipitacion: precipitation_table_edited,
                        }
                        
                    }
                    break;
                case 6:
                    let energy_plant_table_edited = dataEnergy.energy_plant_table.filter((ept:any) => 'edited' in ept && ept.edited === true )
                    let energy_month_table_edited = dataEnergy.energy_month_table.filter((emt:any) => 'edited' in emt && emt.edited === true ).map((item:any) => item)

                    body = {
                        id_scenario_base: parseInt(id),
                        id_scenario: parseInt(id_compare),
                        comparativa: comparativa,
                        id_tab: tabID,
                        settings : {
                            energy: {
                                energy_plant_table: energy_plant_table_edited,
                                energy_month_table: energy_month_table_edited
                            }
                        }
                        
                    }
                    break;
            } 
            
            const res = await updateScenario(body)
            if(res.status === 200) {
                const { code, message } = res.data
                if(code === 200) {
                    setSaveLoading(false)
                    success(message)
                    setFlagChangeScenario(!flagChangeScenario)
                } else {
                    setSaveLoading(false)
                    error(message)
                }
            } else {
                setSaveLoading(false)
                error("Error de conexión")
            }
        } catch(err:any) {
            setSaveLoading(false)
            catchResponse(err)
        }
        
    }

    const emptyData = () => {

        if(tabID !== 1) {
            //setDataPlanificacion({})
            //setDataPlanificacionMASTER({})
        }
        
        if(tabID !==2) {
            setDataProvider({
                provider_table: [],
                contract_table: []
            })

            setDataProviderMASTER({
                provider_table: [],
                contract_table: []
            })
        }
        
        if(tabID !== 3) {
            setDataWarehouse([]) 

            setDataWarehouseMASTER([])
        }
        
        if(tabID !== 4) {
            setDataTransport({
                inflacion_esperada_table : [],
                precio_km_table : []
            })
            setDataTransportMASTER({
                inflacion_esperada_table : [],
                precio_km_table : []
            })
        }

        if(tabID !== 5) {
            setDataPrecipitation({
                precipitation_map: [],
                precipitation_table : []
            })
            setDataPrecipitationMASTER({
                precipitation_map: [],
                precipitation_table : []
            })
        }

        if(tabID !== 6) {
            setDataEnergy({
                energy_month_table : [],
                energy_plant_table : []
            })
            setDataEnergyMASTER({
                energy_month_table : [],
                energy_plant_table : []
            })
        }
   
    }


    const fetchScenarioComparisionByTabID = async () => {
        try {
           
            let body:IScenarioComparision = {
                id_scenario_base: id,
                id_scenario: id_compare,
                id_tab: tabID,
                comparativa: comparativa
            }

            
            const res = await getScenarioComparisionByTabID(body)
            
            if(res.status === 200) {
                const { code,data,message } = res.data
                if(code === 200) {
                    if(comparativa) {
                        setScenarioBase({...data.scenario_base,
                            semana_inicio_planificacion_a:data.settings?.planificaciones?.semana_inicio_planificacion_a,
                            semana_fin_planificacion_a:data.settings?.planificaciones?.semana_fin_planificacion_a,
                            anio_inicio_planificacion_a:data.settings?.planificaciones?.anio_inicio_planificacion_a,
                            anio_fin_planificacion_a:data.settings?.planificaciones?.anio_fin_planificacion_a
                        })
                        setScenarioComparision({...data.scenario,
                            semana_inicio_planificacion_b:data.settings?.planificaciones?.semana_inicio_planificacion_b,
                            semana_fin_planificacion_b:data.settings?.planificaciones?.semana_fin_planificacion_b,
                            anio_inicio_planificacion_b:data.settings?.planificaciones?.anio_inicio_planificacion_b,
                            anio_fin_planificacion_b:data.settings?.planificaciones?.anio_fin_planificacion_b
                        })
                        
                        setSimulated({
                            scenario_base: data.scenario_base.simulated,
                            scenario_comparision: data.scenario.simulated
                        })

                        setOriginal({
                            scenario_base: data.scenario_base.original,
                            scenario_comparision: data.scenario.original
                        })
                    } else {
                        setScenarioBase(data.scenario_base)
                        setScenarioComparision(data.scenario)
                        
                        setSimulated({...simulated,scenario_base: data.scenario_base.simulated})
                        setOriginal({...original,scenario_base: data.scenario_base.original})
                    }

                    switch(tabID) {
                        case 1:
                            let {planificaciones} = data.settings

                            setDataPlanificacion({
                                scenario_base: {
                                    semana_inicio_planificacion_a:planificaciones?.semana_inicio_planificacion_a,
                                    semana_fin_planificacion_a:planificaciones?.semana_fin_planificacion_a,
                                    anio_inicio_planificacion_a:planificaciones?.anio_inicio_planificacion_a,
                                    anio_fin_planificacion_a:planificaciones?.anio_fin_planificacion_a
                                },
                                scenario_comparision : {
                                    semana_inicio_planificacion_b:planificaciones?.semana_inicio_planificacion_b,
                                    semana_fin_planificacion_b:planificaciones?.semana_fin_planificacion_b,
                                    anio_inicio_planificacion_b:planificaciones?.anio_inicio_planificacion_b,
                                    anio_fin_planificacion_b:planificaciones?.anio_fin_planificacion_b
                                }
                            })
        
                            setDataPlanificacionMASTER({
                                scenario_base: {
                                    semana_inicio_planificacion_a:planificaciones?.semana_inicio_planificacion_a,
                                    semana_fin_planificacion_a:planificaciones?.semana_fin_planificacion_a,
                                    anio_inicio_planificacion_a:planificaciones?.anio_inicio_planificacion_a,
                                    anio_fin_planificacion_a:planificaciones?.anio_fin_planificacion_a
                                },
                                scenario_comparision : {
                                    semana_inicio_planificacion_b:planificaciones?.semana_inicio_planificacion_b,
                                    semana_fin_planificacion_b:planificaciones?.semana_fin_planificacion_b,
                                    anio_inicio_planificacion_b:planificaciones?.anio_inicio_planificacion_b,
                                    anio_fin_planificacion_b:planificaciones?.anio_fin_planificacion_b
                                }
                            })
                            
                            emptyData()

                            break;
                        case 2:
                            let {providers} = data.settings
                            setDataProvider(
                                {
                                    provider_table: providers.provider_table,
                                    contract_table: providers.contract_table
                                }
                            )
                
                            setDataProviderMASTER(
                                {
                                    provider_table: providers.provider_table,
                                    contract_table: providers.contract_table
                                }
                            )

                            emptyData()

                            break;
                        case 3:
                            let {warehouse} = data.settings

                   
                            setDataWarehouse(warehouse)
                
                            setDataWarehouseMASTER(warehouse)

                            emptyData()

                            break;
                        case 4:
                            let {transport} = data.settings
                    
                            setDataTransport({
                                precio_km_table: transport.precio_km_table,
                                inflacion_esperada_table: transport.inflacion_esperada_table
                            })
                            setDataTransportMASTER({
                                precio_km_table: transport.precio_km_table,
                                inflacion_esperada_table: transport.inflacion_esperada_table
                            })

                            emptyData()

                            break;
                        case 5:
                            let {precipitation} = data.settings
        
                            setDataPrecipitation({
                                precipitation_map: precipitation.precipitation_map,
                                precipitation_table: precipitation.precipitation_table
                            })
                            setDataPrecipitationMASTER({
                                precipitation_map: precipitation.precipitation_map,
                                precipitation_table: precipitation.precipitation_table
                            })

                            emptyData()

                            break;
                        case 6:
                            let {energy} = data.settings
                    
                            setDataEnergy({
                                energy_plant_table: energy.energy_plant_table,
                                energy_month_table: energy.energy_month_table
                            })
                            setDataEnergyMASTER({
                                energy_plant_table: energy.energy_plant_table,
                                energy_month_table: energy.energy_month_table
                            })

                            emptyData()

                            break;
                        default:
                            
                    }

                    setLoadingTab(false)
                    setLoadingScenarioComparision(false)
                } else {
                    error(message)
                    setLoadingTab(false)
                    setLoadingScenarioComparision(false)
                }
            } else {
                setLoadingTab(false)
                setLoadingScenarioComparision(false)
                catchResponse("Error obteniendo la comparativa de escenarios")
            }
        } catch(err:any) {
            console.log(err)
            setLoadingTab(false)
            setLoadingScenarioComparision(false)
            catchResponse(err)
        }
    }

    const handleSwapScenarios = () => {
        
        let scenario_base = id
        let scenario_to_compare = id_compare
        
        history.push(`/scenario_view/${scenario_to_compare}/${scenario_base}`)
    }

    const renderComparativaLoader = () => {
        switch(tabID) {
            case 1:
                return 'Obteniendo comparativa de escenarios'
            case 2:
                return 'Obteniendo comparativa de los proveedores'
            case 3:
                return 'Obteniendo comparativa de los almacenes'
            case 4:
                return 'Obteniendo comparativa del transporte'
            case 5:
                return 'Obteniendo comparativa de las precipitaciones'
            case 6:
                return 'Obteniendo comparativa de los consumos'
        }
    }

    const renderNoComparativaLoader = () => {
        switch(tabID) {
            case 1:
                return 'Obteniendo la información del escenario'
            case 2:
                return 'Obteniendo información de los proveedores'
            case 3:
                return 'Obteniendo información de los almacenes'
            case 4:
                return 'Obteniendo información de los transportes'
            case 5:
                return 'Obteniendo información de las precipitaciones'
            case 6:
                return 'Obteniendo información de los consumos'
        }
    }

    const fetchAllEscenarios = async() => {
        try {
            const res = await getAllScenarios()
            if(res.status === 200) {
                const { code, data } = res.data
                if( code === 200) {
                    setAllScenarios(data)
                } else {
                    setAllScenarios([])
                    error("No se pueden obtener los escenarios")
                }
            } else {
                setAllScenarios([])
                error("No se pueden obtener los escenarios")
            }
        } catch(err) {
            setAllScenarios([])
            error("No se pueden obtener los escenarios")
        }
    }

    useEffect(() => {
        setLoadingScenarioComparision(true)
        fetchAllEscenarios()
    }, [flagChangeScenario,id,id_compare,comparativa])


    useEffect(() => {
        setLoadingTab(true)
        fetchScenarioComparisionByTabID()
    },[tabID,flagChangeScenario,id,id_compare,comparativa])


    return (
        <div className="scenario__wrapper">
            <ChangeNameModal
                scenarioId={id}
                visible={openChangeNameModal}
                setVisible={setOpenChangeNameModal}
                history={history}
                actualName={scenarioBase?.name_scenario}
                newScenarioName={newScenarioName}
                setNewScenarioName={setNewScenarioName}
                flagChangeScenario={flagChangeScenario}
                setFlagChangeScenario={setFlagChangeScenario}
                scenarioPlant={scenarioBase?.id_plant}
                />
            <LaunchSimulationModal
                scenarioId={id}
                visible={openLaunchSimulationModal}
                setVisible={setOpenLaunchSimulationModal}
                history={history}
                numberQueuedSimulations={numberQueuedSimulations}
                setNumberQueuedSimulations={setNumberQueuedSimulations}
                flagChangeScenario={flagChangeScenario}
                setFlagChangeScenario={setFlagChangeScenario}
                launchError={launchError}
                setLaunchError={setLaunchError}
                launchSuccess={launchSuccess}
                setLaunchSuccess={setLaunchSuccess}
                />
                <ConfirmPopup />
            <div>
            
                <div className="scenario__header-name">
                    <NewScenarioModal
                        visible={visible} 
                        setVisible={setVisible}
                        scenarioPlant={scenarioBase?.id_plant}
                        scenarioBase={`${scenarioBase?.name_planner}(${scenarioBase?.name_plant})`}
                        scenarioBaseName={scenarioBase?.name_scenario}
                        allScenarios={allScenarios}
                        />
                    <ScenarioSelector disabled={loadingScenarioComparision || loadingTab} allScenarios={allScenarios}  scenarioBase={scenarioBase} scenarioToCompare={scenarioToCompare} setFlagChangeScenario={setFlagChangeScenario} flagChangeScenario={flagChangeScenario} title={`(${scenarioBase?.name_plant})`} color={'var(--lis-dark)'} base={true} loadingScenarioComparision={loadingScenarioComparision} />
                    <div className="scenario__header-input" >
                        <span className="p-inputgroup-addon" style={{backgroundColor:'var(--lis-dark)',color:'white'}}>
                            <HiOutlineIdentification style={{fontSize:20}} />
                        </span>
                        
                        <InputText className="scenario-inputs"  placeholder="Nombre de escenario" keyfilter="alphanum" value={loadingScenarioComparision? "" : `${scenarioBase?.name_scenario}`} disabled />
                        
                        
                        
                    </div>
                </div>
                
                <>
                
                    {
                        comparativa?
                        <>
                        <FaExchangeAlt onClick={handleSwapScenarios} style={{minWidth:30,cursor:'pointer'}} />
                            <div className="scenario__header-name">
                                <ScenarioSelector disabled={loadingScenarioComparision || loadingTab}  allScenarios={allScenarios} scenarioBase={scenarioBase} scenarioToCompare={scenarioToCompare} setFlagChangeScenario={setFlagChangeScenario} flagChangeScenario={flagChangeScenario} title={`(${scenarioComparision?.name_plant})`} setScenarioToCompare={setScenarioToCompare} color={'var(--lis-alternative)'} base={false} loadingScenarioComparision={loadingScenarioComparision} />
                                    <div className="scenario__header-input" >
                                        <span className="p-inputgroup-addon"  style={{backgroundColor:'var(--lis-alternative)',color:'white'}}>
                                            <HiOutlineIdentification style={{fontSize:20}} />
                                        </span>
                                        
                                        <InputText  className="scenario-inputs" placeholder="Nombre de escenario" keyfilter="alphanum" value={loadingScenarioComparision? "" : `${scenarioComparision?.name_scenario}`} disabled />
                                        
                                    </div>
                                <span style={{cursor:'pointer'}} onClick={() => setComparativa(false)}>x</span>
                            </div>
                        </>
                        :
                            <>
                            <span style={{minWidth:30}}></span>
                            <div style={{minWidth:'35%'}}>
                                <span style={{fontFamily:'var(--roboto-medium)',fontSize:'0.85rem',cursor:'pointer',color:'gray'}} onClick={() => setComparativa(true)}> + Añadir escenario</span>
                            </div>
                            </>
                    }
                    

                    
                </>
                
                
                <div className="scenario__header-settings">
                    <Tooltip target=".speeddial-scenario .p-speeddial-action" position="bottom" style={{fontSize:'0.75rem'}} />
                    <SpeedDial className="speeddial-scenario" model={items} direction="left" transitionDelay={80} showIcon="pi pi-cog" hideIcon="pi pi-times" buttonClassName="p-button-outlined" />
                </div>
                                

            </div>

            

            <div>
                <div className="card" style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <TabView onClick={handleTabID} >
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <RiProfileLine size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Info. General'}})} />Info. General</span>}>
                            
                            </TabPanel>
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <MdGroup size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Proveedor'}})} />Proveedor</span>}>
                            
                            </TabPanel>
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <FaWarehouse size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Almacén'}})} />Almacén </span>}>
                            
                        </TabPanel>
                        
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <ImTruck size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Transporte'}})} />Transporte </span>}>
                        
                        </TabPanel>
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <BsFillCloudRainFill size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Precipitación'}})} />Precipitación </span>} >
                        
                        </TabPanel>
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <MdEnergySavingsLeaf size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Energía / Consumo'}})} />Energía / Consumo </span>} >
                        
                        </TabPanel>
                    
                    </TabView>
                    <div className="scenario_table_options">
                        
                        <Button rounded outlined onClick={handleRestart} tooltip="Reiniciar datos" tooltipOptions={{ position: 'left',className:"scenario-tooltip-restart"}} style={{padding:'0.45rem',marginBottom:5}} disabled={saveLoading || (state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) : false)} >
                            <VscDebugRestart  size={20}  />
                        </Button>
                        <Button disabled={saveLoading || (state?.rol_id !== undefined? [3,4].includes(state.rol_id) || !state.id_plants.includes(scenarioBase.id_plant) : false)} rounded outlined   style={{padding:'0.45rem', color:'green',marginBottom:5}} tooltip={saveLoading? "Guardando..." :"Guardar modificaciones"} tooltipOptions={{ position: 'left',className:"scenario-tooltip-restart"}}  >
                            {
                                saveLoading?
                                <FiCommand className="loading-icon" style={{fontSize:20}} />
                                :
                                <AiFillSave size={22} onClick={handleSaveData} />
                            }

                        </Button>
                        
                    </div>
                    
                </div>
                    {
                    loadingScenarioComparision || loadingTab?
                        <div style={{height:'95%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                            {/*<Spinner message={comparativa?`Obteniendo comparativa de escenarios` : `Obteniendo información del escenario`}/>*/}
                            <FiCommand className="loading-icon" style={!comparativa? {fontSize:40,color:'var(--lis-dark)',opacity:0.6} : {fontSize:40,color:'var(--lis-alternative)',opacity:0.6}} />
                                {comparativa?
                                    <span style={{fontFamily:'var(--roboto-medium)',color:'gray',marginTop:'1rem'}}>{renderComparativaLoader()}</span>
                                    : 
                                    <span  style={{fontFamily:'var(--roboto-medium)',color:'gray',marginTop:'1rem'}}>{renderNoComparativaLoader()}</span>
                                }
                        </div>
                        
                    :
                
                    tabID === 1?
                                
                        
                            <InformacionGeneral
                                scenarioBase={scenarioBase}
                                scenarioComparision={scenarioComparision}
                                dataPlanificacion={dataPlanificacion}
                                setDataPlanificacion={setDataPlanificacion}
                                dataPlanificacionMASTER={dataPlanificacionMASTER}
                                setDataPlanificacionMASTER={setDataPlanificacionMASTER}
                                simulated={simulated}
                                original={original}
                                comparativa={comparativa}
                                saveLoading={saveLoading}
                                same={id === id_compare}
                            />
                            :
                            tabID === 2?
                            <Proveedor
                                scenarioBase={scenarioBase}
                                data={dataProvider}
                                dataMASTER={dataProviderMASTER}
                                setData={setDataProvider}
                                setDataMASTER={setDataProviderMASTER}
                                simulated={simulated}
                                original={original}
                                comparativa={comparativa}
                                saveLoading={saveLoading}
                                same={id === id_compare}
                            />

                            :
                            tabID === 3?
                                <Pajera
                                    scenarioBase={scenarioBase}
                                    data={dataWarehouse}
                                    dataMASTER={dataWarehouseMASTER}
                                    setData={setDataWarehouse}
                                    setDataMASTER={setDataWarehouseMASTER}
                                    simulated={simulated}
                                    original={original}
                                    comparativa={comparativa}
                                    saveLoading={saveLoading}
                                    same={id === id_compare}
                                    dataPlanificacion={dataPlanificacion}
                                />
                                :
                                tabID === 4?
                                    <Transporte 
                                        scenarioBase={scenarioBase}
                                        data={dataTransport}
                                        dataMASTER={dataTransportMASTER}
                                        setData={setDataTransport}
                                        setDataMASTER={setDataTransportMASTER}
                                        simulated={simulated} 
                                        original={original}
                                        comparativa={comparativa}
                                        saveLoading={saveLoading}
                                        same={id === id_compare}
                                    />
                                    : 
                                    tabID === 5?
                                        <Precipitacion 
                                            scenarioBase={scenarioBase}
                                            data={dataPrecipitation}
                                            dataMASTER={dataPrecipitationMASTER}
                                            setData={setDataPrecipitation}
                                            setDataMASTER={setDataPrecipitationMASTER}
                                            simulated={simulated}
                                            original={original}
                                            comparativa={comparativa}
                                            saveLoading={saveLoading}
                                            same={id === id_compare}
                                        />
                                        :
                                        <Energia
                                            scenarioBase={scenarioBase}
                                            data={dataEnergy}
                                            dataMASTER={dataEnergyMASTER}
                                            setData={setDataEnergy}
                                            setDataMASTER={setDataEnergyMASTER}
                                            simulated={simulated}
                                            original={original}
                                            comparativa={comparativa}
                                            saveLoading={saveLoading}
                                            same={id === id_compare}
                                        />
                }
               
            </div>
            
        </div>
    )
}